import { render } from "./Booking.vue?vue&type=template&id=6323e588&scoped=true&ts=true"
import script from "./Booking.vue?vue&type=script&lang=ts"
export * from "./Booking.vue?vue&type=script&lang=ts"

import "./Booking.vue?vue&type=style&index=0&id=6323e588&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6323e588"]])

export default __exports__